import { Info } from "common-ui-components";
import PropTypes from "prop-types";

const CustomBanner = ({ text, color, icon = <Info size={20} /> }) => {
  return (
    <div className='custom-banner' style={{ backgroundColor: color }}>
      {icon}
      <span>{text}</span>
    </div>
  )
};

export default CustomBanner;

CustomBanner.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
};
